/* Designer Consignor Naples — signature.js
   The Edit's interactive signatures: Vitrine sheen, hero switcher,
   Authentication Theater, Worth estimator, word-reveal, running folio.
   Vanilla, null-safe, reduced-motion + pointer aware. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  /* ---------- Glass / plate cursor sheen ---------- */
  function sheen() {
    if (!fine || reduced) return;
    $all('.glass, .plate').forEach(function (el) {
      var target = el.querySelector('.glass__plate') || el.querySelector('.plate__media') || el;
      var px = 0, py = 0, queued = false;
      function apply() { queued = false; el.style.setProperty('--mx', px + '%'); el.style.setProperty('--my', py + '%'); }
      el.addEventListener('pointermove', function (e) {
        var r = target.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width * 100;
        py = (e.clientY - r.top) / r.height * 100;
        el.classList.add('lit');
        if (!queued) { queued = true; requestAnimationFrame(apply); }
      });
      el.addEventListener('pointerleave', function () { el.classList.remove('lit'); });
    });
  }

  /* ---------- Vitrine hero switcher (curtain wipe) ---------- */
  function vitrine() {
    var stage = $('[data-vitrine-stage]');
    var ticks = $all('[data-vitrine-tick]');
    if (!stage || ticks.length < 2) return;
    var img = stage.querySelector('img');
    var houseEl = $('[data-vitrine-house]');
    var pieceEl = $('[data-vitrine-piece]');
    var priceEl = $('[data-vitrine-price]');
    var linkEl = $('[data-vitrine-view]');
    var plateEl = $('[data-vitrine-plate]');
    var busy = false, current = 0, timer = null;
    var section = stage.closest('.vitrine') || stage;
    var autoplay = parseInt(section.getAttribute('data-vitrine-autoplay') || '0', 10);

    function show(idx) {
      if (busy) return;
      idx = ((idx % ticks.length) + ticks.length) % ticks.length;
      var t = ticks[idx];
      current = idx;
      busy = true;
      ticks.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
      var d = t.dataset;
      function apply() {
        if (img && d.img) { img.src = d.img; img.alt = (d.house || '') + ' ' + (d.piece || ''); }
        if (houseEl) houseEl.textContent = d.house || '';
        if (pieceEl) pieceEl.textContent = d.piece || '';
        if (priceEl) priceEl.textContent = d.price || '';
        if (plateEl && d.plate) plateEl.textContent = d.plate;
        if (linkEl && d.url) linkEl.href = d.url;
      }
      if (reduced || !img) { apply(); busy = false; return; }
      img.style.transition = 'transform .35s cubic-bezier(.16,1,.3,1), opacity .35s ease';
      img.style.transform = 'translateY(-12%)'; img.style.opacity = '0';
      setTimeout(function () {
        apply();
        img.style.transition = 'none';
        img.style.transform = 'translateY(12%)';
        requestAnimationFrame(function () {
          img.style.transition = 'transform .55s cubic-bezier(.16,1,.3,1), opacity .55s ease';
          img.style.transform = 'none'; img.style.opacity = '1';
          setTimeout(function () { busy = false; }, 560);
        });
      }, 360);
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (autoplay && !reduced && ticks.length > 1) { stop(); timer = setInterval(function () { show(current + 1); }, autoplay); } }
    function restart() { stop(); start(); }

    ticks.forEach(function (t, i) { t.addEventListener('click', function () { show(i); restart(); }); });

    if (autoplay && !reduced) {
      section.addEventListener('pointerenter', stop);
      section.addEventListener('pointerleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
      start();
    }
  }

  /* ---------- Vitrine PEEK carousel (cards peeking on each side) ---------- */
  function peekVitrine() {
    var track = $('[data-vitrine-track]');
    if (!track) return;
    var cards = $all('[data-vitrine-card]', track);
    if (!cards.length) return;
    var stage = track.parentNode;
    var section = (stage && stage.closest('.vitrine')) || track;
    var houseEl = $('[data-vitrine-house]');
    var pieceEl = $('[data-vitrine-piece]');
    var priceEl = $('[data-vitrine-price]');
    var linkEl = $('[data-vitrine-view]');
    var plateEl = $('[data-vitrine-plate]');
    var current = 0, timer = null;
    var autoplay = parseInt(section.getAttribute('data-vitrine-autoplay') || '0', 10);

    function layout() {
      var active = cards[current];
      if (!active) return;
      cards.forEach(function (c, i) {
        var on = i === current;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.tabIndex = on ? -1 : 0;
      });
      var x = (stage.clientWidth / 2) - (active.offsetLeft + active.offsetWidth / 2);
      track.style.transform = 'translateX(' + Math.round(x) + 'px)';
      var d = active.dataset;
      if (houseEl) houseEl.textContent = d.house || '';
      if (pieceEl) pieceEl.textContent = d.piece || '';
      if (priceEl) priceEl.textContent = d.price || '';
      if (plateEl && d.plate) plateEl.textContent = d.plate;
      if (linkEl && d.url) linkEl.href = d.url;
    }
    function go(i) { current = ((i % cards.length) + cards.length) % cards.length; layout(); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (autoplay && !reduced && cards.length > 1) { stop(); timer = setInterval(function () { go(current + 1); }, autoplay); } }
    function restart() { stop(); start(); }

    cards.forEach(function (c, i) { c.addEventListener('click', function () { go(i); restart(); }); });
    window.addEventListener('resize', layout);
    if (autoplay && !reduced) {
      section.addEventListener('pointerenter', stop);
      section.addEventListener('pointerleave', start);
      section.addEventListener('focusin', stop);
      section.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    }
    // settle after layout + first image decode so offsets are correct
    layout();
    setTimeout(layout, 60);
    window.addEventListener('load', layout);
    start();
  }

  /* ---------- Word reveal for opening spread ---------- */
  function spread() {
    var q = $('[data-words]');
    if (!q) return;
    var text = q.textContent.trim();
    q.innerHTML = text.split(/\s+/).map(function (w, i) {
      return '<span class="w" style="transition-delay:' + (i * 0.06).toFixed(2) + 's">' + w + '</span>';
    }).join(' ');
  }

  /* ---------- Generic in-view toggler ---------- */
  function inview() {
    var els = $all('.spread, .plate, [data-inview]');
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Authentication Theater ---------- */
  function theater() {
    var stage = $('[data-theater-stage]');
    if (!stage) return;
    var hotspots = $all('[data-theater-hotspot]', stage.closest('.theater') || document);
    var loupe = stage.querySelector('.theater__loupe');
    var noteWrap = $('[data-theater-note]');
    var noteLabel = noteWrap ? noteWrap.querySelector('.label') : null;
    var noteText = noteWrap ? noteWrap.querySelector('.txt') : null;
    var announce = $('[data-theater-announce]');
    var progress = $('[data-theater-progress] span');
    var seal = $('[data-theater-seal]');
    var img = stage.querySelector('img');
    var inspected = {};
    var total = hotspots.length || 1;
    var typer = null;

    if (fine && !reduced && loupe && img) {
      var lpx = 0, lpy = 0, lqueued = false;
      function drawLoupe() {
        lqueued = false;
        var r = stage.getBoundingClientRect();
        var src = img.currentSrc || img.src;
        if (!src) return;
        loupe.style.left = lpx + 'px'; loupe.style.top = lpy + 'px';
        loupe.style.transform = 'translate(-50%,-50%)';
        loupe.style.backgroundImage = 'url(' + src + ')';
        loupe.style.backgroundSize = (r.width * 2) + 'px ' + (r.height * 2) + 'px';
        loupe.style.backgroundPosition = (-(lpx * 2 - 75)) + 'px ' + (-(lpy * 2 - 75)) + 'px';
      }
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        lpx = e.clientX - r.left; lpy = e.clientY - r.top;
        stage.classList.add('zooming');
        if (!lqueued) { lqueued = true; requestAnimationFrame(drawLoupe); }
      });
      stage.addEventListener('pointerleave', function () { stage.classList.remove('zooming'); });
    }

    function type(text) {
      if (!noteText) return;
      if (typer) clearInterval(typer);
      if (reduced) { noteText.textContent = text; return; }
      var i = 0; noteText.textContent = '';
      typer = setInterval(function () {
        noteText.textContent = text.slice(0, i++);
        if (i > text.length) clearInterval(typer);
      }, 16);
    }
    function activate(h, idx) {
      hotspots.forEach(function (x) { x.setAttribute('aria-pressed', x === h ? 'true' : 'false'); });
      var label = h.dataset.label || '';
      var note = h.dataset.note || '';
      if (noteLabel) noteLabel.textContent = label;
      type(note);
      if (announce) announce.textContent = label + '. ' + note;
      inspected[idx] = true;
      var n = Object.keys(inspected).length;
      if (progress) progress.style.width = Math.min(n / total * 100, 100) + '%';
      if (n >= total && seal) seal.classList.add('shown');
    }
    hotspots.forEach(function (h, idx) {
      h.addEventListener('click', function () { activate(h, idx); });
      h.addEventListener('mouseenter', function () { if (fine) activate(h, idx); });
    });
  }

  /* ---------- What's Your Piece Worth estimator ---------- */
  function worth() {
    var root = $('[data-worth]');
    if (!root) return;
    var TIER = {
      'Hermès': 'ultra', 'Chanel': 'premier', 'Louis Vuitton': 'premier', 'Cartier': 'premier',
      'Gucci': 'luxury', 'Prada': 'luxury', 'Dior': 'luxury', 'Saint Laurent': 'luxury',
      'Bottega Veneta': 'luxury', 'Celine': 'luxury', 'Valentino': 'luxury', 'Fendi': 'luxury',
      'Other': 'contemporary'
    };
    var BANDS = {
      ultra:        { Handbag: [3500, 18000], Apparel: [400, 2500], Shoes: [300, 1200], Jewelry: [800, 9000], Accessory: [200, 3000] },
      premier:      { Handbag: [1200, 7000],  Apparel: [250, 1800], Shoes: [180, 900],  Jewelry: [400, 6000], Accessory: [120, 1500] },
      luxury:       { Handbag: [400, 2500],   Apparel: [150, 1200], Shoes: [120, 600],  Jewelry: [150, 2000], Accessory: [80, 800] },
      contemporary: { Handbag: [120, 700],    Apparel: [60, 500],   Shoes: [60, 300],   Jewelry: [60, 800],   Accessory: [40, 350] }
    };
    var COND = [0.5, 0.66, 0.78, 0.9, 1.0];
    var state = { designer: null, category: null, cond: 4 };

    var rangeEl = $('[data-worth-range]', root);
    var needle = $('[data-worth-needle]', root);
    var capEl = $('[data-worth-cap]', root);

    function clampRound(v) { return Math.max(10, Math.round(v / 10) * 10); }
    function compute() {
      if (!state.designer || !state.category) return;
      var tier = TIER[state.designer] || 'contemporary';
      var band = BANDS[tier][state.category] || [50, 500];
      var m = COND[state.cond - 1];
      var lo = clampRound(band[0] * m), hi = clampRound(band[1] * m);
      animateRange(lo, hi);
      var mid = Math.sqrt(lo * hi);
      var t = Math.min(Math.max((Math.log(mid) - Math.log(80)) / (Math.log(20000) - Math.log(80)), 0), 1);
      if (needle && !reduced) needle.style.transform = 'rotate(' + (-90 + t * 180) + 'deg)';
      else if (needle) needle.style.transform = 'rotate(' + (-90 + t * 180) + 'deg)';
      if (capEl) capEl.textContent = 'Estimated consignment value';
    }
    var raf;
    function animateRange(lo, hi) {
      if (!rangeEl) return;
      if (reduced) { rangeEl.textContent = money(lo) + ' – ' + money(hi); return; }
      cancelAnimationFrame(raf);
      var start = null, dur = 900;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        rangeEl.textContent = money(lo * e) + ' – ' + money(hi * e);
        if (p < 1) raf = requestAnimationFrame(step);
      }
      raf = requestAnimationFrame(step);
    }

    $all('[data-designer]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        state.designer = b.dataset.designer;
        $all('[data-designer]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        compute();
      });
    });
    $all('[data-category]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        state.category = b.dataset.category;
        $all('[data-category]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        compute();
      });
    });
    var dots = $all('[data-cond]', root);
    var condLabel = $('[data-cond-label]', root);
    var CONDNAMES = ['Fair', 'Good', 'Very Good', 'Excellent', 'Pristine'];
    function setCond(v) {
      state.cond = v;
      dots.forEach(function (d, i) { d.classList.toggle('on', i < v); d.setAttribute('aria-pressed', i < v ? 'true' : 'false'); });
      if (condLabel) condLabel.textContent = CONDNAMES[v - 1];
      compute();
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { setCond(i + 1); }); });
    if (dots.length) setCond(4);
  }

  /* ---------- Running folio ---------- */
  function folio() {
    var bar = $('[data-folio-mid]');
    if (!bar) return;
    var sections = $all('[data-folio-label]');
    if (!sections.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) bar.textContent = x.target.getAttribute('data-folio-label'); });
    }, { threshold: 0.5 });
    sections.forEach(function (s) { io.observe(s); });
  }

  /* ---------- Acquisition-notes placard rotation ---------- */
  function placard() {
    var wrap = $('[data-placard]');
    if (!wrap) return;
    var figs = $all('figure', wrap);
    if (figs.length < 2) return;
    var i = 0;
    setInterval(function () {
      figs[i].classList.remove('on');
      i = (i + 1) % figs.length;
      figs[i].classList.add('on');
    }, 5200);
  }

  document.addEventListener('DOMContentLoaded', function () {
    spread();
    inview();
    sheen();
    vitrine();
    peekVitrine();
    theater();
    worth();
    placard();
    folio();
  });
})();
